module.exports = __webpack_public_path__ + "static/media/10-01.0c3f0f03.png";